import { useState } from "react"
import { useListCleaningJobs } from "../../../../hooks/cleaning"
import { getProfile } from "../../../../utils/api"
import { Box, CircularProgress, Divider, ListItem, ListItemIcon, ListItemText, Stack, Typography } from "@mui/material"
import Group from "../../../../components/Group"
import { FIRE_ALARM_USE_ICON } from "../../../../utils/const"
import { getStatusColor } from "../../../../utils/ColourStatus"
import { DataCleaningJobType } from "../../../../hooks/cleaning/index.type"
import cleanIcon from '../../../../assets/cleaning/clean-icon.png';
import EmptySection from "../../../../components/molecules/EmptySection"
import { GeneralRobotInfo, JobData, RobotStatus2 } from "../../../robots/components/v2/_type"
import { COLOR } from "../../../../utils/colors"

interface RobotInfo {
  robotStatus?: RobotStatus2;
  jobs?: JobData;
  generalInfo: GeneralRobotInfo;
}

export default function ListCleaningJobByRobot({
  robotId,
  onSelectJob
}: {
  robotId: any,
  onSelectJob: (job: DataCleaningJobType) => void;
}) {
  const organisation = getProfile()?.organisation
  const [page] = useState(1)
  const { data, isLoading } = useListCleaningJobs({ organisation_id: organisation, page, no_end_time: true, robot_id: robotId.robotStatus?.robot_id })
  const listJobs = data?.data || []

  const filterListJobs = listJobs.filter((item) => true)

  const handleSelectedJob = (jobDetails: DataCleaningJobType) => {
    onSelectJob?.(jobDetails)
  }

  return (
    <Box>
      {!isLoading && filterListJobs.length > 0 && filterListJobs.map((data, index) => (
        <Group key={index}>
          <ListItem key={index} sx={{ py: 1, '&:hover': { backgroundColor: '#f4f4f4', cursor: 'pointer' }, paddingLeft: "35px" }} onClick={() => handleSelectedJob(data)}>
            <ListItemIcon>
              <Stack sx={{ mr: 2, width: "60px", height: "60px", bgcolor: "#f5f5f5", color: "white", fontWeight: "600", borderRadius: "30px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <img src={cleanIcon} style={{ width: FIRE_ALARM_USE_ICON ? "30px" : "40px", height: FIRE_ALARM_USE_ICON ? "30px" : "40px", objectFit: "scale-down" }} />
              </Stack>
              {/* <Box sx={{backgroundColor:"#E6E6E6", borderRadius:"20px", width:"35px", height:"35px"}}>
                                                    <div style={{display:"flex", justifyContent:"center", alignItems:"center", padding:"3px"}}>
                                                        <img src={swiftbot} style={{ width: "30px", height: "30px", margin:"auto" }} />
                                                    </div>
                                                    </Box> */}
            </ListItemIcon>
            <ListItemText>
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "right" }}>
                <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                  <Typography sx={{ color: "#000", fontSize: "16px", fontWeight: "500" }}>
                    {/* Job #{job.order_number.slice(-5).toUpperCase()} */}
                    {data.job_number}
                  </Typography>
                  <Typography sx={{ color: "#727272", fontSize: "12px" }}>
                    {/* convert date time to date and pm/am */}
                    {new Date(data.created_time).toLocaleDateString()}, {new Date(data.created_time).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}

                  </Typography>
                </Box>
                <Typography sx={{ color: getStatusColor(data.status), fontSize: "12px" }}>
                  {data.status.replace(/_/g, " ").split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")}
                </Typography>
              </Box>
            </ListItemText>
          </ListItem>
          {index < filterListJobs.length - 1 && <Divider />}
        </Group>
      ))}

      {!isLoading && filterListJobs.length === 0 && (
        <EmptySection />
      )}
      {isLoading && (
        <Box sx={{ display: 'flex', flexDirection: "column", justifyContent: 'center', alignItems: 'center', height: '100%', mt: 1 }}>
          <CircularProgress />
          <Typography
            sx={{
              mt: 2,
              color: COLOR.gray[500],
              fontSize: "12px",
            }}
          >
            Loading...
          </Typography>
        </Box>
      )}
    </Box>
  )
}